import styled from "styled-components";
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
export const Image = styled.div`
  width: 20%;
  background-color: #2555ef;
  min-height: 631px;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const StepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  margin-top: 30px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center;
  justify-content: flex-start; */
  width: 100%;
`;
export const CardsScroll = styled.div`
  overflow-x: auto;
  min-width: 0;
  width: 100%;
  &::-webkit-scrollbar-track {
    margin-left: 24px;
    margin-right: 24px;
  }
`;
export const CardsRow = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  width: max-content;
  min-width: 100%;
  padding: 0 24px 8px;
  box-sizing: border-box;
`;
export const CampaignIcon = styled.div`
  height: 72px;
  width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
  }

  .push-notification-icon {
    width: 64px;
    height: 64px;
  }
  .push-notification-icon path {
    fill: #aec6f3;
  }
  .push-notification-icon rect {
    fill: #2555ef;
    opacity: 1;
  }
`;
export const TitleCampaignCards = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
flex-direction: column;
color:#002E5C;
margin-top: 10px;
h1{
font-size: 20px;
font-weight: bold;
line-height: 32px;
}
span{
  font-size: 15px;
font-weight: 400;
line-height: 25.6px;
}
`
export const Title = styled.span`
color: #002E5C;
font-size: 20px;
font-weight: bold;
`;
export const Desc = styled.span`
color: #404253;
font-size: 14px;
margin-top: 20px;
width: 160px;
word-wrap: break-word;
text-align: center;
`;

export const Button = styled.button`
display: "flex";
align-items: "center";
width: 86px;
height: 44px;
background-color:rgb(37 85 239 / 8%);
color:${(props)=>props.disabled ?'#d2d7e5':'#2555EF'};
border-radius: 5px;
position:absolute;
bottom:18px;

`;
